import { render, staticRenderFns } from "./AdminCompanyOverview.vue?vue&type=template&id=77b1ba22&scoped=true&"
import script from "./AdminCompanyOverview.vue?vue&type=script&lang=ts&"
export * from "./AdminCompanyOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCompanyOverview.vue?vue&type=style&index=0&id=77b1ba22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1ba22",
  null
  
)

export default component.exports